import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { mountPackReveal, RevealCard, PackRevealShare } from './packRevealEngine';
import './PackReveal.css';

/* Full-screen pack-open reveal for a claimed card pack. Rendered into a portal on
 * document.body so nothing in the portal layout can clip or z-index it, and driven
 * by the vanilla engine (which builds its own DOM inside our container and cleans
 * up on unmount). Mount only when there are cards to reveal. */
export const PackRevealOverlay: React.FC<{
  cards: RevealCard[];
  /* the claim's share link (null = the server recorded no pull: no Share button) */
  share?: PackRevealShare | null;
  onClose: () => void;
}> = ({ cards, share, onClose }) => {
  const ref = useRef<HTMLDivElement>(null);
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    const el = ref.current;
    if (!el || !cards.length) return;
    const handle = mountPackReveal(el, cards, () => onCloseRef.current(), { share: share || null });
    return () => handle.destroy();
    // Mount once: a claim's cards are fixed for the life of the overlay.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return createPortal(<div ref={ref} />, document.body);
};

export default PackRevealOverlay;
